type Reservation = {
  heights: Map<symbol, number>;
  inlinePadding: string;
  basePadding: number;
};

const reservations = new WeakMap<Document, Reservation>();

function apply(doc: Document, reservation: Reservation): void {
  let tallest = 0;
  reservation.heights.forEach((height) => {
    tallest = Math.max(tallest, height);
  });
  const value =
    tallest > 0
      ? `${reservation.basePadding + tallest}px`
      : reservation.inlinePadding;
  if (value) doc.body.style.setProperty('padding-bottom', value);
  else doc.body.style.removeProperty('padding-bottom');
}

/**
 * Pads the bottom of the page by the tallest bar docked there, so the last
 * of the page's content can still scroll clear of it. The page's own
 * padding is kept underneath and restored when every bar has released.
 */
export function reserveBottomSpace(
  doc: Document,
  key: symbol,
  height: number,
): void {
  let reservation = reservations.get(doc);
  if (!reservation) {
    const view = doc.defaultView;
    const computed = view
      ? Number.parseFloat(view.getComputedStyle(doc.body).paddingBottom)
      : 0;
    reservation = {
      heights: new Map(),
      inlinePadding: doc.body.style.paddingBottom,
      basePadding: Number.isFinite(computed) ? computed : 0,
    };
    reservations.set(doc, reservation);
  }
  reservation.heights.set(key, Math.max(0, height));
  apply(doc, reservation);
}

export function releaseBottomSpace(doc: Document, key: symbol): void {
  const reservation = reservations.get(doc);
  if (!reservation) return;
  reservation.heights.delete(key);
  apply(doc, reservation);
  if (reservation.heights.size === 0) reservations.delete(doc);
}
